export default __webpack_public_path__ + "static/media/plaque1.613a5c58.jpg";